import React, { useContext } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { AuthContext } from "../AuthContext";
import MainLayout from "../layouts/MainLayout";
import Landing from "../pages/Landing";
import Login from "../pages/Login";
import Register from "../pages/Register";
import ForgotPassword from "../pages/ForgotPassword";
import ResetPassword from "../pages/ResetPassword";
import NotFound from "../pages/NotFound";
import ApplicationsPage from "../pages/Applications";
import Welcome from "../pages/Welcome";
import Profile from "../pages/Profile";

const PrivateRoute = ({ children }) => {
  const { user, loading, initialized } = useContext(AuthContext);
  if (!initialized || loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

export default function AppRoutes() {
  return (
    <Routes>
       <Route path="login" element={<Login />} />
       <Route path="register" element={<Register />} />
       <Route path="forgot-password" element={<ForgotPassword />} />
       <Route path="reset-password" element={<ResetPassword />} />
      <Route element={<MainLayout />}>
        <Route index element={<Landing />} />
        <Route path="applications" element={<ApplicationsPage />} />
        <Route
          path="welcome"
          element={
            <PrivateRoute>
              <Welcome />
            </PrivateRoute>
          }
        />
        <Route
          path="profile"
          element={
            <PrivateRoute>
              <Profile />
            </PrivateRoute>
          }
        />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}
